export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-09.jpg'),
        title: '云',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '硬件、软件、网络的集成',
      description: `<p style="font-size:1.05rem">云是WAN或LAN中硬件，软件，网络和其他资源的集成，实现数据的计算，存储，处理和共享。 随着互联网行业的高度发展和应用，未来每个项目都可能有自己的识别标记，需要传输到后端系统进行逻辑处理。 不同级别的数据将分别处理，各种行业数据需要强大的系统备份支持，这只能通过云计算来实现。 MaesInfo依靠强大的软件开发团队为您提供稳定，可靠，安全和可持续的云服务。</p>`
    },
    {
      title: '我们的服务包括:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-09.jpg')+`)"></span>
      <span class="list">
      <i></i>移动互联<br/>
      <i></i>树液<br/>
      <i></i>办公室云<br/>
      <i></i>上层云迁移<br/>
      <i></i>企业云盘<br/>
      <i></i>日志分析

      </span>`
    }
  ]
}
